var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/object-is-prototype-of.js
// module id = 128
// module chunks = 0